import { render, staticRenderFns } from "./BatchRecords.vue?vue&type=template&id=6579659a&scoped=true&"
import script from "./BatchRecords.vue?vue&type=script&lang=js&"
export * from "./BatchRecords.vue?vue&type=script&lang=js&"
import style0 from "./BatchRecords.vue?vue&type=style&index=0&id=6579659a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6579659a",
  null
  
)

export default component.exports